/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const MonitoringDetailsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 34 34"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M31.3333333,28.6666667 C31.3333333,30.1333333 30.1333333,31.3333333 28.6666667,31.3333333 L3.33333333,31.3333333 C1.86533333,31.3333333 0.666666667,30.1333333 0.666666667,28.6666667 L0.666666667,3.33333333 C0.666666667,1.86533333 1.86533333,0.666666667 3.33333333,0.666666667 L28.6666667,0.666666667 C30.1333333,0.666666667 31.3333333,1.86533333 31.3333333,3.33333333 L31.3333333,28.6666667 Z" />
      <polyline points="0.666666667 12.6666667 6 12.6666667 8.66666667 8.66533333 11.3333333 12.6653333 14 6.66533333 18 19.332 21.3333333 3.332 24 12.6666667 31.3333333 12.6666667" />
      <path d="M6,27.3333333 L6,28.6666667" />
      <path d="M14,27.3333333 L14,28.6666667" />
      <path d="M22,27.3333333 L22,28.6666667" />
      <path d="M10,24.6666667 L10,28.6666667" />
      <path d="M18,24.6666667 L18,28.6666667" />
      <path d="M26,24.6666667 L26,28.6666667" />
    </g>
  </svg>
);

export default MonitoringDetailsIcon;
